{
  "version": 1,
  "asset_id": "557dc967-1be2-4345-8d5f-a19fc51135eb",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/557dc967-1be2-4345-8d5f-a19fc51135eb/clip-img_2096-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/557dc967-1be2-4345-8d5f-a19fc51135eb/clip-img_2096-poster-sm.webp",
  "original_filename": "clip-img_2096-poster-sm.webp",
  "size": 13906,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:23Z"
}
